<div class="card-outer">
    <div class="card-inner flex align-items-center justify-content-start gap-4">
        <div class="icon-wrapper px-2 py-1">
            <img width="20" height="20" src="assets/demo/images/new-driver.png" alt="avatar" class="avatar" />
        </div>
        <div class="driver-content flex flex-column gap-1 align-items-start justify-content-start">
            <span class="text-600 font-bold text-l">{{driver.firstname}} {{driver.surname}}</span>
            <div class="flex align-items-center gap-2">
                <i class="pi pi-id-card id-icon"></i>
                <span class="text-500 driver-id-number">{{driver.identificationNumber}}</span>
            </div>
        </div>
        <div class="flex flex-row align-items-center justify-content-end flex-1" *ngIf="driver.status==='DELETED'">
            <div class="status-dot deleted-dot mr-2"></div>
            <span class="deleted-text">Deleted</span>
        </div>
        <div class="flex flex-row align-items-center justify-content-end flex-1" *ngIf="driver.status==='ACTIVE'">
            <div class="status-dot active-dot mr-2"></div>
            <span class="active-text">Active</span>
        </div>
    </div>
</div>
